module.exports = __webpack_public_path__ + "img/rmwp.8f36a9ad.png";